var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMinTenureCheckIcon = function SvgMinTenureCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "minTenureCheckIcon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#minTenureCheckIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 19.495v-6.577c0-.354-.12-.651-.36-.89a1.21 1.21 0 0 0-.891-.36c-.355 0-.651.12-.89.36a1.21 1.21 0 0 0-.36.89v6.962a1.5 1.5 0 0 0 .452 1.08l5.709 5.708c.23.23.52.349.87.354.35.005.644-.113.886-.354.241-.241.362-.534.362-.878s-.12-.637-.362-.878l-5.417-5.417Zm-1.248 16.34c-2.19 0-4.248-.416-6.175-1.247-1.927-.831-3.603-1.96-5.028-3.384-1.426-1.425-2.554-3.1-3.386-5.026-.831-1.926-1.247-3.984-1.247-6.174 0-2.19.416-4.248 1.247-6.175.83-1.927 1.959-3.603 3.383-5.029 1.425-1.425 3.1-2.553 5.027-3.385 1.926-.831 3.984-1.247 6.174-1.247 2.19 0 4.248.416 6.175 1.247 1.927.83 3.603 1.959 5.028 3.383 1.426 1.425 2.554 3.1 3.385 5.027.832 1.926 1.248 3.984 1.248 6.174 0 2.19-.416 4.248-1.247 6.175-.831 1.927-1.96 3.603-3.384 5.028-1.425 1.425-3.1 2.554-5.026 3.385-1.926.832-3.984 1.248-6.174 1.248Zm-.003-2.5c3.695 0 6.84-1.299 9.438-3.896 2.597-2.598 3.896-5.743 3.896-9.438 0-3.694-1.299-6.84-3.896-9.437-2.597-2.597-5.743-3.896-9.438-3.896-3.694 0-6.84 1.299-9.437 3.896C7.965 13.16 6.666 16.307 6.666 20c0 3.695 1.299 6.84 3.896 9.438 2.597 2.597 5.743 3.896 9.437 3.896Z",
    fill: "#047992"
  }))));
};
export default SvgMinTenureCheckIcon;